import { IIconProps } from "./types"

export default function IconVec2(props: IIconProps) {
  const width = props.size || props.width || 36
  const height = props.size || props.height || 17
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 36 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72541 7.43217L4.64221 2.27506L20.2808 0L23.6637 7.27956L5.72541 7.43217Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2939 13.7951H29.2096V17L36 12.7267L29.2096 8.47113V11.6619H21.2939V13.7951Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84914 8.92953L18.4852 9.05376L17.6788 15.1975L0.645001 13.1035L0 6.17171L2.72389 5.93395L3.84914 8.92953Z"
        fill="#3A3939"
      />
    </svg>
  )
}
